<template>
    <div class="users">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>企业列表</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="margin-top: 1rem; padding: 1.5rem 1rem 0 1rem; background-color: white">
            <el-form :inline="true" :model="query">
                <el-form-item label="企业名称:">
                    <el-input v-model="query.name" placeholder="企业名称"></el-input>
                </el-form-item>
                <el-form-item label="企业代码:">
                    <el-input v-model="query.code" placeholder="企业代码"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onQuery">查询</el-button>
                    <el-button type="default" @click="query = {}">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="margin-top: 1rem; padding: 1rem; background-color: white">
            <el-button type="primary" style="margin-bottom: 1rem" @click="$router.push('/enterprise/create')" size="small">添加企业</el-button>
            <el-table
                    :data="enterprises"
                    border
                    stripe
                    v-loading="loading"
                    style="width: 100%">

                <el-table-column
                        sortable
                        :sort-method="(a, b) => a.name.localeCompare(b.name, 'zh')"
                        prop="name"
                        label="企业名称">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="code"
                        label="企业代码">
                </el-table-column>
                <el-table-column
                        sortable
                        :sort-method="(a, b) => a.address ? a.address.localeCompare(b.address, 'zh') : -1"
                        prop="address"
                        label="企业地址">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="tel"
                        label="企业电话">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="creator"
                        label="创建人"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="createTime"
                        label="创建时间"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="updator"
                        label="更新人"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="updateTime"
                        label="更新时间"
                >
                </el-table-column>
                <el-table-column label="操作" v-if="auth.accountType != 1">
                    <template slot-scope="scope">
                        <el-button @click="$router.push('/enterprise/edit?id=' + scope.row.id)" type="text" size="small">编辑</el-button>
<!--                        <el-button @click="$router.push('/user/address?id=' + scope.row.id)" type="text" size="small">配送地址</el-button>-->
                        <el-button @click="deleteDevice(scope.row.id)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>

            </el-table>
            <div style="text-align: center">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pagination.page"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import enterpriseApi from "../../api/enterprise";
    import {mapState} from "vuex";
    export default {
        data: function () {
            return {
                enterprises: [],
                loading: false,
                total: 0,
                pagination: {
                    page: sessionStorage.getItem("page") || 1,
                    pageSize: 10
                },
                query: {

                },
            }
        },
        computed: {
            ...mapState("auth", {
                auth: state => state
            }),
        },
        mounted() {
            this.loadUsers();
        },
        methods: {
            deleteDevice: function(id) {
                this.$confirm('确定删除该企业？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    enterpriseApi.deleteById(id).then(result => {
                        this.loading = false;
                        this.loadUsers();
                    })
                });
            },
            loadUsers: function () {
                this.loading = true;
                enterpriseApi.getAll(this.query, this.pagination).then(result => {
                    this.loading = false;
                    this.enterprises = result.data;
                    this.total = result.total;
                })
            },
            onQuery: function () {
                this.pagination = {
                    ...this.pagination,
                    page: 1,
                }
                this.loadUsers();
            },
            handleSizeChange: function (size) {
                this.pagination = {
                    page: 1,
                    pageSize: size
                }
                this.loadUsers();
            },
            handleCurrentChange: function (page) {
                sessionStorage.setItem("page", page);
                this.pagination = {
                    ...this.pagination,
                    page: page,
                }
                this.loadUsers();
            },
        }
    }
</script>
